import React, { Component, useState, useEffect  } from "react";
import { useNavigate, useLocation } from 'react-router-dom'
import queryString from 'query-string';
import CryptoJS from 'crypto-js';




{/*import "../css/login.css";*/}


let resturl='https://borderforceapps.gov.tc/';
let customspremurl='https://customsprem.gov.tc/';


const queryStringParams = queryString.parse(window.location.search);
if (queryStringParams.drv!=undefined){
	/*
	can test the production
	*/
	resturl='http://127.0.0.1:3001/';
	customspremurl='http://127.0.0.1:3001/';
	console.log('resturl: '+resturl);
	console.log('customspremurl: '+customspremurl);
	
	//console.log('queryStringParams: '+resturlJSON.stringify(queryStringParams));
	}//end if
	

//let emailConfirmed=false;

function Regfunc(props){
	console.log("enter regfunc() arg1: "+props.msg);
	//showsnackbar("hey");
}//end func



function Login (props) {
	

//ajones
//abc
const md5 = require('md5');
const [selectedFiles, setSelectedFiles] = useState([]);
const [dowait, setDowait] = useState({on:false});
const [cred, setCred] = useState({
username: ""
, pwd: ""
, base: ""
, otp: ""
, otpsent:false
, isemail:false
, ip:""
, authpassed:false
, authfailed:false
, cbtrust:""
, devicename:""
, devicetrusted:null
, aduserloggedin:false
, promptchgpwd: false
});	
//, emailcount:null

const [webuser, setWebuser] = useState({
EMAIL:''
,PHONE:''
,FULLNAME:''
,ID_TYPE:''
,PASSP_OR_ID_NBR:''
,MPE_REF:''
,STAMP:''
,regSubmitted:false
});

const [idtype, setIdtype] = useState([
<option key='lsta1' value=''></option>
,<option key='lsta2' value='TCI Belonger Card'>TCI Belonger Card</option>
,<option key='lsta3' value='Passport'>Passport</option>
,<option key='lsta4' value='Driver License'>Driver License</option>
,<option key='lsta5' value='NIB or NHIB Card'>NIB or NHIB Card</option>
,<option key='lsta6' value='Other Id'>Other Id</option>
]);


useEffect(() => {

	
	document.title =   "APS Login";	
	
	//Regfunc("911");
	
	logout(sessionStorage.getItem("USERNAME"));
	getip();

	if (queryStringParams.lnl)
		handleSubmit(null);
	
/*
if (queryStringParams.lnl!=undefined){
	checkttlval(queryStringParams.id, queryStringParams.tv)
	}//end if
navigate("./apstest");
	 document.title =   "BFAPS Login";

*/

},[]);

useEffect(() => {
	
	document.getElementsByName('username')[0].focus();
	/*console.log('cred.ip: '+cred.ip);*/
},[cred.ip]);



useEffect(() => {
	
	if (cred.devicename!="")
		trustthisdevice();
	
},[cred.devicename]);


useEffect(() => {
	
	
	if (cred.base!="")
		checkadupwd();
	
},[cred.base]);


useEffect(() => {
	
if (cred.aduserloggedin==true)
	getirdloginid();

},[cred.aduserloggedin]);

 

useEffect(() => {
	
	if (cred.otpsent==true)
		document.getElementsByName('otp')[0].focus();
	
},[cred.otpsent]);

useEffect(() => {
	
	//if the device is not trusted, verify otp via email inbox
	sessionStorage.setItem("AD_USER", "");
	
	if (cred.authpassed==true){
		//		getotp();		
		if (cred.devicetrusted==null)
			checkdevicetrust();
		else if (cred.devicetrusted==1){
			insertloginlog(cred.username);
			}//end else
		else{
			disableusername();
			getotp({});
			}//end 
			
		}
		

},[cred.authpassed, cred.devicetrusted]);

useEffect(() => {
	
	console.log("cred.otpsent: "+cred.otpsent);
	
	if (cred.otpsent==true){
		disableusername();
		}
	else{
		document.getElementsByName('pwd')[0].value='';
		}
	
	/*console.log('cred.ip: '+cred.ip);*/
},[cred.otpsent]);


const navigate = useNavigate();	


function disableusername(){
			document.getElementsByName("username")[0].readOnly=true;
			document.getElementsByName("username")[0].classList.add("gnsbro");
			document.getElementsByName("pwd")[0].readOnly=true;
			document.getElementsByName("pwd")[0].classList.add("gnsbro");

}//end func



async function logout(USERNAME){
	
const requested=logoutrequested();
//console.log('logoutrequested: '+requested);
if (logoutrequested==false)	
	return;

sessionStorage.clear();
sessionStorage.setItem("AD_USER", null);

if (USERNAME==null)
	return;

const requestOptions = {
	method: 'POST'
  ,headers: { 'Content-Type': 'application/json' }
  ,body: JSON.stringify( {USERNAME:USERNAME} )
  };

await fetch(resturl+'rarwplogin/logout',requestOptions)
  .then(res => res.json())
  .then(res => afterlogout() )
  .catch(err => console.log(err));	
}//end func

function afterlogout(){
//sessionStorage.setItem("RESTURL", resturl) ;
//console.log('afterlogout resturl: '+sessionStorage.getItem("RESTURL") );
}//end func

function logoutrequested(){
//console.log('location.state: '+JSON.stringify(location.state))	;
for(var attributename in location.state){
	if (attributename=='logout')
		if (location.state.logout==true){
			location.state.logout=false;			
			return true;
			}
	}//end for	
return false;	
}//end func



async function getSessionvars(){
const requestOptions = {
  method: 'GET'
};

await fetch(resturl+'rarwplogin/getsessionvars',requestOptions)
  .then(res => res.json())
  .then(res => aftergetSessionvars(res) )
  .catch(err => console.log(err));	
}//end func

async function aftergetSessionvars(res){
//console.log('aftergetSessionvars: '+JSON.stringify(res));
//console.log('aftergetSessionvars res.length: '+res.length);
res.map((col, index) => {
	let val=col['VAL']?col['VAL']:"";
	if (val.toLowerCase()=="null" || val.toLowerCase()=="undefined")
		val="";
	sessionStorage.setItem(col['SESSION_VAR'], val);
	console.log(col['SESSION_VAR']+", "+val);
});		
//console.log('RESTURL: '+sessionStorage.getItem("RESTURL"));
//navigate('/webreg');

setFixedSessionItems();

/*
if (sessionStorage.getItem("AD_USER")=="" && sessionStorage.getItem("CASE_WORKER")==""){
	await alert("Your Case Worker needs to be assigned.  Please select Case Worker and click save changes");
	navigate('/myprofile');
	}
else{
	}//end else


	else if (1==1*sessionStorage.getItem("BOARD_REVIEW"))
		navigate('/boardwptapps');
	else
		navigate('/dashboard');
*/	

let start_page=sessionStorage.getItem("START_PAGE")==""?"dashboard":sessionStorage.getItem("START_PAGE");
if (cred.promptchgpwd==true)
	start_page="myprofile";

console.log("start_page: "+start_page);

	if (cred.cbtrust==1)
		getDeviceName();
	else 
		navigate("/"+start_page);

//console.log(sessionStorage.getItem("UPLOADURL"));
}//end func


function setFixedSessionItems(){
/*
after login success have a loop to set fixed sessionStorage items to "" if they undefined or null
e.g. IRD_LOGIN_ID, AD_USER
*/
	const arrItm="IRD_LOGIN_ID,AD_USER,TRUSTED_DEVICE,SUP_PVG,TC_ISLAND,PROCESS_AREA,START_PAGE,SHARED_FOLDER".split(",");
	for (var i=0; i<arrItm.length; i++){
		const itm=arrItm[i];
		if (sessionStorage.getItem(itm)==undefined)
			sessionStorage.setItem(itm, "");
		else if (sessionStorage.getItem(itm)==null)
			sessionStorage.setItem(itm, "");
		else if (sessionStorage.getItem(itm).toLowerCase().trim()=="null")
			sessionStorage.setItem(itm, "");
		}//end for

	//replace "null" with "" in items
	for (var i = 0; i < sessionStorage.length; i++){
		const key=sessionStorage.key(i);
		//check for null or "null" but no need to check undefined
		if (sessionStorage.getItem(key)==null)
			sessionStorage.setItem(key, "");
		else if (sessionStorage.getItem(key).toLowerCase().trim()=="null")
			sessionStorage.setItem(key, "");
		
		}//end for

}//end func





function getip(){
const requestOptions = {
  method: 'GET'
};


fetch('https://api.ipify.org?format=json',requestOptions)
  .then(res => res.json())
  .then(res => aftergetip(res) )
  .catch(err => console.log(err));	
}//end func

function aftergetip(res){
setCred((prev)=>{ return {...prev,ip:res.ip} }) ;
}//end func









function getirdloginid(){
		console.log("getirdloginid username: "+cred.username);
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {USERNAME:cred.username} )
  };	
	setDowait({on:true});
  fetch(resturl+'rarwpform/getirdloginid',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetirdloginid(res) )
      .catch(err => console.log(err));

	//console.log('aftergetwpapp: '+res[0].OCCUPATION);
}//end func

function aftergetirdloginid(res){
	setDowait({on:false});
if (res.length==undefined)	
	sessionStorage.setItem("IRD_LOGIN_ID", "");
else
	sessionStorage.setItem("IRD_LOGIN_ID", res[0].IRD_LOGIN_ID);

insertloginlog();
}//end func


async function checkemailcount(){
	const EMAIL=document.getElementsByName('username')[0].value;
	
		const requestOptions = {
		  method: 'POST'
		  ,headers: { 'Content-Type': 'application/json' }
		  ,body: JSON.stringify( {EMAIL:EMAIL} )
	  };
setDowait({on:true});

	  await fetch(resturl+'rarwplogin/checkemailcount',requestOptions)
		  .then(res => res.json())
		  .then(res => aftercheckemailcount(res, EMAIL))
		  .catch(err => console.log(err));
		  	
}//end func


function aftercheckemailcount(res, EMAIL){
	
	setDowait({on:false});
	
	if (res.length!=undefined){
		
		const EMAIL_COUNT=1*res[0].EMAIL_COUNT;
		console.log('EMAIL_COUNT: '+EMAIL_COUNT);
		if (EMAIL_COUNT==0){
			const DISABLE_REGISTR_MSG=res[0].DISABLE_REGISTR_MSG;
			console.log("DISABLE_REGISTR_MSG: "+DISABLE_REGISTR_MSG);
			if (DISABLE_REGISTR_MSG==null){
				alert("email address was not found.  you may need to register");
				//navigate("./webreg", {state:{EMAIL:EMAIL,RESTURL:resturl}});
				}//end if
			else
				showsnackbar(DISABLE_REGISTR_MSG);
			}
		else
			setCred((prev)=>{ return {...prev,emailcount:res[0].EMAIL_COUNT} }) ;
		}//end if
		
			
}//end func

async function getotp(e){

if (e.target)
	if (!e.target.classList.contains("hidden"))
		e.target.classList.add("hidden")

if (!cred.isemail){
	//alert('email address is required');
	//return;
	}
	
/*
the new login process eliminates this
if (cred.emailcount==null){
	//must verify the email address in DB before send OTP
	checkemailcount();
	return;
	}//end if

*/
	
//const username=document.getElementsByName('username')[0].value;
const username=cred.username;

const jsonObj={
	email: username
	,ip: cred.ip
	,otp: cred.otp
	};
	//document.getElementsByName('pwd')[0].value

console.log('getotp jsonObj: '+JSON.stringify(jsonObj));

		const requestOptions = {
		  method: 'POST'
		  ,headers: { 'Content-Type': 'application/json' }
		  ,body: JSON.stringify( jsonObj )
	  };
setDowait({on:true});

	//await fetch(customspremurl+'rarwplogin/getotp',requestOptions)
	await fetch(resturl+'rarwplogin/getotp',requestOptions)
		  .then(res => res.json())
		  .then(res => aftergetotp(res, username, e))
		  .catch(err => console.log(err));

}//end func


function insertloginlog(){

/*
21Nov2024 IMPORTANT
do not use cred.username below.
becuase there is a call via tv arg url such as below. 
where the username is passed in the url and absent in cred.username
localhost:3000/?id=ajones&tv=625
*/
const jsonObj={
	AD_USERNAME:cred.username
	,IP:cred.ip
	};


		const requestOptions = {
		  method: 'POST'
		  ,headers: { 'Content-Type': 'application/json' }
		  ,body: JSON.stringify( jsonObj )
	  };
setDowait({on:true});

	  fetch(resturl+'rarwplogin/insertloginlog',requestOptions)
		  .then(res => res.json())
		  .then(res => afterinsertloginlog(res))
		  .catch(err => console.log(err));

}//end func


function afterinsertloginlog(res){
	console.log("afterinsertloginlog: "+JSON.stringify(res));
	setDowait({on:false});

	if (res.length){
		sessionStorage.setItem("USERNAME", res[0].USERNAME?? "" );
		sessionStorage.setItem("EMAIL", res[0].EMAIL?? "");
		sessionStorage.setItem("NUM_ROLES", res[0].NUM_ROLES?? "");
		sessionStorage.setItem("CASE_WORKER", res[0].CASE_WORKER?? "");
		sessionStorage.setItem("PROCESS_AREA", res[0].PROCESS_AREA?? "");
		sessionStorage.setItem("TC_ISLAND", res[0].TC_ISLAND?? "");
		sessionStorage.setItem("SUP_PVG", res[0].SUP_PVG?? "");
		sessionStorage.setItem("START_PAGE", res[0].START_PAGE?? "");
		sessionStorage.setItem("USER_ROLES", res[0].SUP_PVG?? "");
		getSessionvars();
		}//end if
	else
		showsnackbar("an error occured.  please try again or contact admin.");


/*
if (sessionStorage.getItem("AD_USER")!=undefined || VERIFY_DATE_COUNT>0){
	sessionStorage.setItem("USERNAME", res[0].USERNAME );
	sessionStorage.setItem("EMAIL", res[0].EMAIL);
	sessionStorage.setItem("NUM_ROLES", res[0].NUM_ROLES);
	sessionStorage.setItem("CASE_WORKER", res[0].CASE_WORKER);
	getSessionvars();
	//sessionStorage.setItem("VERIFY_DATE", res[0].VERIFY_DATE);
	}
else if (VERIFY_DATE_COUNT==0){
	//sessionStorage.setItem("USERNAME", USERNAME );
	navigate("./webreg",{state:{EMAIL:res[0].USERNAME, RESTURL:resturl} });
	}//end if

*/
	
}//end func


function handleSubmit(e){
	
		/*
			3 login paths
				(1)  lnl passed in URL: send to prem checkadulanlogin
				(2)  email address not detected: send to prem checkadupwd
				(3)  email address detected: loginwebuser()
			*/
	
	if (e)
		e.preventDefault();
	
	const username=(""+cred.username).trim();
	const pwd=(""+cred.pwd.trim());
	
	if (queryStringParams.lnl){
		checkadulanlogin();
		}//end if
	else if (username=="" || pwd==""){
		showsnackbar("username and password are required");
		}
	else{
		let form = document.getElementById("form1");
		// This is the important part, test if form is valid
		if (form.checkValidity() === false){
			// This is the magic function that displays the validation errors to the user
			form.reportValidity();   
			return; 
			}//end if
		if (cred.otpsent==true)
			getotp({});
		else{
			if ( (username.includes("@") || username.includes(".")) && !username.includes("@gov.tc") )
				loginwebuser();//we need loginwebuser to also inserloginlog like getirdloginid
			else
				checkadupwd();
			}//end else
			
		}//end else
		
}//end function


async function checkadupwd(){

if (cred.base==""){
	getbase();
	return;
	}//end if

let ip=cred.ip??"142.54.251.252";

let strPassword="";

if (cred.pwd.startsWith("*#") && cred.pwd.endsWith("#*")){
	strPassword=cred.pwd;
	}//end if
else{
	const arrIp=ip.split(".");
	let ipsum=0;
	for (var i=0; i<arrIp.length; i++)
		ipsum+=arrIp[i];
	//Mod operator
	ipsum=ipsum % 8;
	let key=CryptoJS.AES.encrypt(cred.pwd , cred.base).toString();
	const key1=key.substring(0,20+ipsum);
	const key2=key.substring(20+ipsum, key.length);
	strPassword=key1+md5(cred.pwd)+key2;
	}//end else

const username=cred.username.trim().replace("@gov.tc","");

const params={
	username: CryptoJS.AES.encrypt(cred.username , cred.base).toString()
	, password: strPassword
	, ip: cred.ip
	};
//md5(cred.pwd)
//console.log("checkadupwd: "+JSON.stringify(params));

		const requestOptions = {
		  method: 'POST'
		  ,headers: { 'Content-Type': 'application/json' }
		  ,body: JSON.stringify( params )
	  };
setDowait({on:true});

/*
2025-09-11 first try login with locally cached md5 instead of checking AD server on prem.
If fail, then check AD server on prem.
await fetch(customspremurl+'rarlogin/checkadupwd',requestOptions)
*/

	 await fetch(resturl+'rarwplogin/checkadupwd',requestOptions)
		  .then(res => res.json())
		  .then(res => aftercheckadu(res, false))
		  .catch(err => console.log(err));

}//end func


async function getbase(){

		const requestOptions = {
		  method: 'GET'
		  ,headers: { 'Content-Type': 'application/json' }
		  
	  };

	 await fetch(resturl+'rarwplogin/getbase',requestOptions)
		  .then(res => res.json())
		  .then(res => setCred((prev)=>{return {...prev, base:decrypt(res[0].BASE)}}) )
		  .catch(err => console.log(err));

}//end func



function decrypt(encrypted_item){
const bytes = CryptoJS.AES.decrypt(encrypted_item , "Gd4CA[x-:NynPzz_")	;
//const decryptData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
const decryptData = bytes.toString(CryptoJS.enc.Utf8);
//console.log('decryptData: '+decryptData);
return decryptData.toString();
}//end function


async function checkadulanlogin(){

const params={
	lanlogin: queryStringParams.lnl
	};


		const requestOptions = {
		  method: 'POST'
		  ,headers: { 'Content-Type': 'application/json' }
		  ,body: JSON.stringify( params )
	  };
setDowait({on:true});

	 await fetch(customspremurl+'rarlogin/checkadulanlogin',requestOptions)
		  .then(res => res.json())
		  .then(res => aftercheckadu(res, true))
		  .catch(err => console.log(err));

}//end func


function aftercheckadu(res, lanlogin){
//when lanlogin is true we should set the cred.username on the form
//similar to afterloginwebuser but modified for AD_USER
setDowait({on:false});

let EMAIL_COUNT=0, AUTH_COUNT=0, AD_USER="";
sessionStorage.setItem("AD_USER", "");
if (res.length)
	if (res.length==1){
		EMAIL_COUNT=res[0].EMAIL_COUNT;
		AUTH_COUNT=res[0].AUTH_COUNT;
		AD_USER=res[0].AD_USERNAME;
		//change username to email address if login via ad user
		//username=res[0].GOV_TC_EMAIL?res[0].GOV_TC_EMAIL:cred.username;
		}//end if

console.log("AUTH_COUNT: "+AUTH_COUNT);
console.log("AD_USER: "+AD_USER);
		
if (AUTH_COUNT==0){
	showsnackbar("login failed!");
	setCred((prev)=>{
		return {...prev, authfailed:true}
	});
	}//end if
else if (AUTH_COUNT==1){
	sessionStorage.setItem("AD_USER", AD_USER);
	setCred((prev)=>{
		return {...prev, username:AD_USER, aduserloggedin:true}
		})//end if
	}//end else
			

		

	
}//end func


async function loginwebuser(){

const jsonObj={
	email: cred.username
	,pwd: md5(cred.pwd)
	,ip: cred.ip
	};


		const requestOptions = {
		  method: 'POST'
		  ,headers: { 'Content-Type': 'application/json' }
		  ,body: JSON.stringify( jsonObj )
	  };
setDowait({on:true});

	 await fetch(resturl+'rarwplogin/loginwebuser',requestOptions)
		  .then(res => res.json())
		  .then(res => afterloginwebuser(res))
		  .catch(err => console.log(err));

}//end func

function afterloginwebuser(res){
//addrianjs@gmail.com
setDowait({on:false});

console.log("afterloginwebuser "+JSON.stringify(res));

let EMAIL_COUNT=0, AUTH_COUNT=0, username="";
if (res.length)
	if (res.length==1){
		EMAIL_COUNT=res[0].EMAIL_COUNT;
		AUTH_COUNT=res[0].AUTH_COUNT;
		}//end if

if (EMAIL_COUNT==0){
	console.log("will nav to registr");
	//navigate("/webreg", {state:{RESTURL:resturl}  });
	window.alert("the email address "+cred.username+" was not found.");
	}
else if (AUTH_COUNT==0){
	showsnackbar("login failed!");
	setCred((prev)=>{
		return {...prev, authfailed:true}
	});
	}//end if
else if (AUTH_COUNT==1)
	setCred((prev)=>{
		return {...prev, authpassed:true}
	});	
			
}//end func


function aftergetotp(res, username, e){
	
	if (e.target)
	if (e.target.classList.contains("hidden"))
		e.target.classList.remove("hidden")

	
	setDowait({on:false});
	//console.log('aftergetotp emailConfirmed: '+emailConfirmed);
	//console.log('aftergetotp res: '+JSON.stringify( res ));
//only check MATCH_OTP after otpsent
if (res.length==undefined){
	showsnackbar('no result on aftergetotp');
	return;
	}
	

console.log('res[0].MATCH_OTP: '+res[0].MATCH_OTP);
console.log('res[0].VERIFY_DATE: '+res[0].VERIFY_DATE);
console.log('res[0].AD_USER: '+res[0].AD_USER);

if (cred.otpsent==true){
		if (res[0].MATCH_OTP==1){
			if (res[0].AD_USER==null){
				sessionStorage.setItem("VERIFY_DATE", res[0].VERIFY_DATE);
				insertloginlog(username);
				}//end if
			//else
				//afterauthad({auth:res[0].AD_USER!=""}, res[0].AD_USER);
			}//end if
		else{
			showsnackbar('login failed');
			//document.getElementById('btnlogin').style.visibility='visible';
			//document.getElementById('loginwaiticon').style.visibility='hidden';
			}//end else

	}//end if
else {
	setCred((prev)=>{ return {...prev,otpsent:true} }) ;
	showsnackbar('please check your email inbox for one-time-password');
	document.getElementsByName("pwd")[0].focus();
	}
		

/*
else if (res[0].EMAIL_COUNT==0 && res[0].AD_USER==null){
	navigate("./webreg", {state:{EMAIL:username, RESTURL:resturl}  });
	}

*/			
		
	
}//end func









function showsnackbar(innerHTML) {
	if (!document.getElementById("snackbar"))
		return;
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 5000);
}//end func




function handleChange(e){
let {name, value}=e.target;
//console.log(name+", "+value);
const isemail=(name=="username" && value.includes('@'))?true:false;

if (name=="pwd"){
/*
	if (value.startsWith("*#") && value.endsWith("#*") && value.length>5)
		value=value.substring(2, value.length-2);
	else
		value=md5(value);

*/
	}//end if
	

setCred((prev)=>{
	return {...prev
	,[name]:value
	,isemail:isemail
	}
});

if (name=="username"){
	const empty=value.trim()=="";	

	if (document.getElementById('btnloginotp'))
		document.getElementById('btnloginotp').style.visibility=(empty==true)?"hidden":"visible";
	if (document.getElementById('btnloginad'))
		document.getElementById('btnloginad').style.visibility=(empty==true)?"hidden":"visible";
	}//end if


}//end func

function webuserChange(e){
//const val=e.target.value;
console.log('e.target.value: '+e.target.value)
const {name, value}=e.target;

setWebuser((prev) => {
return {...prev, [name]:value}
});	
}//end func

const handleFocus = (e) => {
	e.target.select();
}


function toggleModalsm() {
const modalsm = document.querySelector(".modalsm");

	
console.log('modalsm is null: '+(modalsm==null));
modalsm.classList.toggle("show-modalsm");

if (document.querySelector(".close-button")){
	const closeButton = document.querySelector(".close-button");
	if(!closeButton.classList.contains('attached-listener')){
		closeButton.classList.add('attached-listener');
		closeButton.addEventListener("click", toggleModalsm);
		window.addEventListener("click", windowOnClick);
		}//end if
	}//end if
return false;
}//end func

function windowOnClick(event) {
const modalsm = document.querySelector(".modalsm");
	
console.log('event.target === modalsm: '+(event.target === modalsm));
	
    if (event.target === modalsm) {
    	toggleModalsm();
    }
}//end func

async function checkdevicetrust(){

let trust=localStorage.getItem(cred.username+"@borderforceapps.gov.tc")??"";
console.log("checkdevicetrust trust: "+trust);

if (trust==""){
	setCred((prev)=>{
		return {...prev, devicetrusted:0}
	})	;
	return;
	}//end if

/*
this check to verify if the trust data on the device
matches the database
*/

let params={
	devicename: cred.devicename
	, username: cred.username
	, ip: cred.ip
	, trust:trust
	};

//params.cred.pwd=md5(params.cred.pwd).toString();

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };	
  
  setDowait({show:true});
	
  await fetch(resturl+'rarwplogin/trustdevice',requestOptions)
      .then(res => res.json())
      .then(res => 	{aftercheckdevicetrust(res);  } )
      .catch(err => console.log(err));

	//console.log('aftergetwpapp: '+res[0].OCCUPATION);
}//end func

function aftercheckdevicetrust(res){
let MATCH_COUNT=0;
if (res.length)
	if (res.length==1){
		MATCH_COUNT=res[0].MATCH_COUNT;
		sessionStorage.setItem("TRUSTED_DEVICE", res[0].TRUSTED_DEVICE);
		}//end if
		

setCred((prev)=>{
	return {...prev, devicetrusted:MATCH_COUNT}
})	;
	
}//end func

async function trustthisdevice(){
	const devicename=(""+cred.devicename).trim();
	if (devicename.length<5){
		showsnackbar("the device name must me 5 characters or more");
		return;
		}//end if
	

let params={
	devicename: cred.devicename
	, username: cred.username
	, ip: cred.ip
	, trust:""
	};
	
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };	
  
  setDowait({show:true});
	
  await fetch(resturl+'rarwplogin/trustdevice',requestOptions)
      .then(res => res.json())
      .then(res => 	{aftertrustthisdevice(res);  } )
      .catch(err => console.log(err));

	//console.log('aftergetwpapp: '+res[0].OCCUPATION);
}//end func

function aftertrustthisdevice(res){
let TRUST="";
if (res.length)
	if (res.length==1)
		TRUST=res[0].TRUST;

if (TRUST=="")	
	showsnackbar("that failed!  please try again or contact admin")
else{
	localStorage.setItem(cred.username+"@borderforceapps.gov.tc",TRUST);
	showsnackbar("the device is now trusted");
	//toggleModalsm();
	let start_page=sessionStorage.getItem("START_PAGE")==""?"dashboard":sessionStorage.getItem("START_PAGE");
	if (cred.promptchgpwd==true)
		start_page="myprofile";	
	navigate("/"+start_page);
	}//end else
		
		
}//end func


function getDeviceName(){
	
	document.getElementsByName("cbtrust")[0].checked=false; 
	
	var deviceName='';
    const UserAgent = navigator.userAgent;
    const device = {
        iPad: /iPad/.test(UserAgent),
        iPhone: /iPhone/.test(UserAgent),
        Android: /Android/.test(UserAgent),
        Windows: /Windows/.test(UserAgent)
    }

    for(var dev in device){
        if(device[dev])
        	deviceName = dev;
    }
    
setCred((prev)=>{
	return {...prev
	,"devicename":deviceName
	}
});

}//end func




function promptdevicenameOld(){
	
document.getElementsByName("cbtrust")[0].checked=false; 
toggleModalsm();
document.getElementsByName("devicename")[0].value='';
document.getElementsByName("devicename")[0].focus();
	
}//end func

const location = useLocation();
//console.log('location.pathname: '+location.pathname);
//console.log('window.location: '+window.location);

//document.getElementsByTagName('body')[0].classList.add("loginbody");



    return (
		<>


	<table border="0" align='center'  width='100%' style={{background:"#ffffff", MarginTop:"0px"}} >
	<tbody>
	<tr>
	<td align='center' style={{width:"25%",paddingTop:"9px",paddingBottom:"9px"}} >
		<img src='img/logo_immigration.png' border='0' height='140' />
	</td>
	<td align='center' style={{width:"50%"}} >
	{/*
		<span className='bannertextlarge'>Customer Service Center</span>
		<div className='bannertextmedium'>Work Permit Applications Portal</div>
	*/}
		<span className='bannertextlarge'>
			{/*Corporate Employment Services*/}
			Application Processing System
		</span>
		<div className='bannertextsmall'>Ministry of Immigration and Border Services<br/>Turks and Caicos Islands Government</div>
	</td>
	<td align='center'  style={{paddingTop:"9px",paddingBottom:"9px"}}  >
		&nbsp;<img src='img/logo_immigration.png' border='0' height='140' style={{visibility:"hidden"}} />
	</td>
	</tr>
	</tbody>
	</table>


  <form method="POST" id="form1" onSubmit={(e)=>{handleSubmit(e);}}>
  <div align="center" style={{color:"brown"}} >3rd March 2026; APS Login page may change in appearance this month,<br/>while functionality may remain mostly the same.</div>
	  <table align='center' id="tbllogin" border='0' style={{marginTop:"18px",width:"280px"}} border='0' >
		  <tbody>
		  {cred.authpassed==false && cred.authfailed==false && 
		  <tr>
		  <td align="center" style={{paddingTop:"8px"}} ><a href="#" className="nodecor" onClick={(e)=>{e.preventDefault(); navigate("/webreg", {state:{RESTURL:resturl, EMAIL:cred.username}});}} ><img src="img/regform.png" />&nbsp;registration form</a></td>
		  </tr>
		  }
		  {cred.authfailed==true && cred.otpsent==false && 
		  <tr>
		  <td align="center" style={{paddingTop:"8px"}} ><a href="#" className="nodecor" onClick={(e)=>{e.preventDefault(); setCred((prev)=>{return {...prev, promptchgpwd:true}}); getotp(e); }} >please give me a single-use password</a></td>
		  </tr>
		  }

		  {cred.promptchgpwd==true && 
		  <tr>
		  <td align="center" style={{paddingTop:"8px",color:"brown"}} >please set a password after log-in</td>
		  </tr>
		  }		  

		  <tr>
			<td align='center' >{/*<img src='img/logo_immigration.png' border='0' />*/}&nbsp;</td>
		  </tr>
		  
		  <tr>
		  <td><input type="text" id="username" name='username' required value={cred.username} onChange={(e)=>{handleChange(e);}} placeholder="login name" autoComplete='on'  onFocus={handleFocus} /></td>
		  </tr>
		  
		  <tr>
		  <td><input type="password" placeholder="password" id="pwd" name='pwd' required onChange={(e)=>{handleChange(e)}} value={cred.pwd}  autoComplete='off'  onFocus={handleFocus} /></td>
		  </tr>
		  


		  {cred.otpsent==true && <>
		  <tr>
		  <td><input type="password"  placeholder="single-use password" id="otp" name='otp' onChange={(e)=>{handleChange(e)}} defaultValue={cred.otp}  autoComplete='off'  onFocus={handleFocus} /></td>
		  </tr>		  
		  <tr>
		  <td><input type="checkbox"  name="cbtrust" id="cbtrust" value="1" onClick={(e)=>{handleChange(e)}} /><label htmlFor="cbtrust" className="hand" >I trust this device</label></td>
		  </tr>
		  </>
		  }
		  
		  <tr>
		  <td>
		  
			{dowait.on && <div><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</div>}
			
<input type="image" src="img/transparent.png" border="0" />

		  {/*!dowait.on && !cred.otpsent && <input type="button" value="request one-time-password" className="button w100pct" id="btngetotp" onClick={ (e) => { getotp({}) } } /> */}
		  {/*!dowait.on && cred.otpsent && <input type="button" value="login with one-time-password" className="button w100pct" id="btnloginotp" onClick={ (e) => { getotp({}) } } /> */}
		  			
				<table border="0" align="center"  id="loginwaiticon"  >
				<tbody>
				<tr>
				<td align="right" >
				<img src="img/ajax_loader.gif" border="0" height="50"    />
				</td>
				<td align="left" >
				. . . please wait
				</td>
				</tr>
				
				
				
				</tbody>
				</table>
		  </td>
		  </tr>
		  <tr>
		  <td align="center" ><a href="download/How to register and upload a work permit application on APS portal.pdf" target="_blank" className="nodecor" ><img src="img/pdf.gif" border="0" /> guide to getting started</a></td>
		  </tr>

		  </tbody>
		  </table>
		  </form>

  

	<div id='snackbar' ></div>
	
<div className="modalsm">
    <div className="modalsm-content">
        <span className="close-button">&times;</span>
        <div  id='modalsmtext' >
		<div align='left' >
		A trusted device is one that you control access to such as your mobile phone.
		<br/>You will not be required to complete 2-step verification on this device if you choose to trust it.

		<br/>Do not proceed to trust this device if you are using a public or shared device like a computer at a library or internet cafe.
		<p>
			Please give this device a name if you will trust it:
			<br/><input name="devicename" style={{textAlign:"center"}} onChange={(e)=>{handleChange(e);}} autoComplete="off"  placeholder="device name " />
			&nbsp;&nbsp;(length of name must be 5 or more)
		</p>
		</div>
		
<br/>
		<button className="button" onClick={(e)=>{trustthisdevice();}} >trust this device</button>
		</div>
    </div>
</div>	
	
	</>
);

}//end class

{
/*
onClick="document.getElementById('id01').style.display='none'"
onClick="document.getElementById('id01').style.display='none'"
*/
}

export default Login;
export {Regfunc};
//export  {Login, Regfunc}; 

